<template>
   <el-popover
     :placement="placement"
     :title="title"
     :width="width"
     :trigger="trigger"
    >
     <div>
       <slot></slot>
     </div>
     <img src="/static/icon/helpIcon.png" alt="提示"  :style="tipStyle" slot="reference">
   </el-popover>
</template>

<script>
  export default {
    props:{
      content:[String],
      width:{
        type:Number,
        default:200
      },
      trigger:{
        type:String,
        default:"hover"
      },
      placement:{
        type:String,
        default:"bottom"
      },
      title:{
        type:String,
        default:""
      },
      tipStyle:{
        type:Object,
        default:()=>{
          return {
            width:"14px",
            height:"14px",
            marginLeft:"6px"
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/publicTips/popoverTip.vue